/**
 * @typedef Sessions
 * @param axios
 * @returns {{list(payload: number): Promise}}
 * @returns {{delete(token: [string, number]): Promise}}
 * @returns {{deleteAll(): Promise}}
 */
export const Sessions = (axios) => ({
  /**
   * Get sessions
   *
   * @param {number} page
   *
   * @returns Promise
   */
  list(page) {
    return axios.get('/v1/sessions', { params: { page } })
  },

  /**
   * Get sessions
   *
   * @returns Promise
   */
  getTemporaryTalentAccess() {
    return axios.get('/v1/sessions/temporary/talent/token')
  },

  /**
   * Delete session
   *
   * @param {string|number} token
   *
   * @returns Promise
   */
  delete(token) {
    return axios.delete(`/v1/sessions/${token}`)
  },

  /**
   * Delete all sessions
   *
   * @returns Promise
   */
  deleteAll() {
    return axios.delete('/v1/sessions/')
  }
})
